<template>
  <div :class="['upload-new-wrap', {'no-submit': isSuccess}, {'has-result': !isNew}, `${page_style}`]" v-if="!toSubmit">

    <div class="upload-content">
      <h1 v-if="banner.title">{{banner.title}}</h1>
      <div class="exam-wrap">
        <img-v3 :src="pics[0]" alt="" class="exam-pic" @click="showScale" />
        <div class="video-wrap" @click="playVideo" v-if="formItem.exam_video_url">
          <video id="video-exam" v-if="isIOS">
            <source :src="videos[0]" type="video/mp4">
          </video>
          <img-v3 class="exam-bg" :src="pics[0]" alt="" />
          <img-v3 class="play-icon" :src="require('../images/play_video.png')" alt="" />
        </div>
        <div class="video-fullscreen" v-if="scaleVideo">
          <div class="bg-mask"></div>
          <video id="video-exam" controls="controls" @click="playVideo('play')">
            <source :src="videos[0]" type="video/mp4">
          </video>
          <img-v3 class="close-big-icon" :src="require('../images/close-white.png')" @click="closeBigVideo"/>
        </div>
        <scale ref="scaleRef" :img-url="pics[0]"></scale>
      </div>

      <div class="upload-tips" v-if="formItem.pic_desc">
        <h5 class="tips-title">{{pic_desc.title}}</h5>
        <p class="tips-desc" v-for="(item,i) in pic_desc.content" :key="i" v-html="item" @click="richTextClick($event)"></p>
      </div>
      <div class="obtain-tips" v-if="formItem.obtain_desc">
        <h5 class="tips-title">{{obtain_desc.title}}</h5>
        <div v-for="(item,i) in obtain_desc.content" :key="i">
          <text-link v-if="item.link" :formItem="item"></text-link>
          <p class="tips-desc" v-else-if="item.text" v-html="item.text" @click="richTextClick($event)"></p>
        </div>


      </div>
      <div class="error-case-tips" v-if="formItem.error_cases">
        <h5 class="tips-title">{{error_cases.title}}</h5>
        <div class="case-list">
          <div class="case-wrap" v-for="(item,i) in error_cases.cases || []" :key="i">
            <div class="img-wrap">
              <img-v3 class="case-img" :src="item.img_url" alt="" />
            </div>
            <div class="case-desc" :style="{color:item.text_color}"><img-v3 class="error-icon" :src="item.icon_url" alt="" />{{item.desc}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="upload-input-wrapper">
      <div class="out-upload-input" :style="uploadBtnStyle">
        <template v-if="inApp">
          <input type="button" @click="selectImg" />
          {{isNew ? uploadBtn.un_check.title: uploadBtn.is_check.title}}
        </template>
        <template v-else>
          <input id="photo" type="file" accept="application/pdf" v-if="formItem.type === 'photo_pdf_new'"/>
          <input v-else-if="formItem.limit_status && formItem.type !== 'photo_pdf_new'" id="photo" type="file" accept="image/*" capture="camera">
          <input id="photo" type="file" accept="image/*" v-else/>
          {{isNew ? uploadBtn.un_check.title: uploadBtn.is_check.title}}
        </template>
      </div>
    </div>

  </div>
  <div :class="['reUpload-img', `${page_style}`]" v-else>
    <div :class="['status-wrap', {'ing': isIng}, {'success': isSuccess}, {'fail': isFailed}]" v-if="!isNew">
      <p>{{formItem.field_result}}</p>
    </div>
    <div class="reUpload-img-header">
      <img-v3 :src="isPDF ? success_pic : uploadImgSrc" />
    </div>
    <div class="confirm-text" v-if="canSubmit">{{$t('GDriver_optimize_Identification_of_FJYI')}}</div>
    <div class="bottom-area" v-show="!isSuccess">
      <!-- <a class="btn-submit" @click="uploadImg" v-if="canSubmit" :style="canSubmit ? active_submit_style : disabled_submit_style">{{submitBtn.is_check.title}}</a> -->
      <a class="btn-reUpload" @click="clearImg" :style="reset_btn_style">{{resetBtn.un_check.title}}</a>
    </div>
    <ocr
      :ocr_config="formItem.ocr_config"
      :job_type="formItem.job_type"
      :job_uid="formItem.job_uid"
      :form_key="formItem.key"
      :radio_type_key="formItem.radio_type_key"
      :radio_type_value="formItem.radio_type_value"
      :show_ocr="show_ocr"
      :ocr_img="ocr_img"
      :submit_btn="submitBtn"
      :reset_btn="resetBtn"
      :page_style="page_style"
      v-show="show_ocr"
      @closeOcr="closeOcr"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import { post } from "../tools/request";
import { showLoadingToast, showToast, showAlertDialog } from "../tools/Tip";
import scale from "../components/base/Scale";
import ocr from "../components/base/Ocr";
import TextLink from '../components/base/text-link-new';
import Input from "../components/base/Input";
import { imgCompress, pdfReader } from "../tools/utils";
import { ends } from "../tools/constant";

export default {
  components: {
    Input,
    scale,
    ocr,
    TextLink
  },
  data() {
    return {
      backConfig: {},
      toSubmit: false, //页面模块控制
      // popVisible: false,
      canSubmit: false, //提交按钮控制
      uploadImgSrc: "",
      show_ocr: false,
      ocr_img: "",
      b2md5: null,
      store_result: null,
      submitFlag: true,
      scaleVideo: false
    }
  },
  props: [
    "auditConfig",
    "idx",
    "is_ocr",
    "dialogStyle",
    "page_type",
    "is_finished",
    "canUpload",
  ],
  computed: {
    ...mapState(["_ticket"]),
    inApp() {
      return !!Fusion.pickImage;
    },
    hasChooseImage() {
      return !!Fusion.chooseImage;
    },
    isIOS() {
      return ends.isIOS
    },
    //传递过来整个对象
    formItem() {
      let c = this.isFleetPCFunnel ? this.auditConfig : this.$route.params.configs;
      return c || {};
    },
    page_style() {
      return this.$route.params.page_style || this.dialogStyle;
    },
    isFleetPCFunnel() {
      return ["h5_funnel_fleet_pc"].includes(this.page_style);
    },
    isPDF() {
      return this.formItem.type === 'photo_pdf_new'
    },
    banner() {
      return this.formItem.banner || {};
    },
    pics() {
      return this.formItem.exam_pic_url || [];
    },
    success_pic() {
      return (this.formItem.exam_pdf_success_pic_url || [])[0];
    },
    videos() {
      return this.formItem.exam_video_url || [];
    },
    pic_desc() {
      return this.formItem.pic_desc || {};
    },
    obtain_desc() {
      return this.formItem.obtain_desc || {};
    },
    error_cases() {
      return this.formItem.error_cases || {};
    },
    checkStatus() {
      return this.formItem.field_status;
    },
    isNew() {
      return this.formItem.field_status == 0 || this.formItem.field_status == 6;
    },
    isIng() {
      return this.formItem.field_status == 3;
    },
    isSuccess() {
      return this.formItem.field_status == 4;
    },
    isFailed() {
      return this.formItem.field_status == 5;
    },
    uploadBtn() {
      return (this.formItem.upload_button || {}).button_color || { un_check: {}, is_check: {} };
    },
    submitBtn() {
      return (this.formItem.confirm_button || {}).button_color || { un_check: {}, is_check: {} };
    },
    resetBtn() {
      return (this.formItem.reset_button || {}).button_color || { un_check: {}, is_check: {} };
    },
    uploadBtnStyle() { // 第一次上传
      let btnColor = this.uploadBtn.un_check;
      return {
        color: btnColor.text_color,
        background: btnColor.background_color,
        border: btnColor.border || 'none'
      }
    },
    reUploadBtnStyle() { // 审核中和审核失败重新上传
      let btnColor = this.uploadBtn.is_check;
      return {
        color: btnColor.text_color,
        background: btnColor.background_color,
        border: btnColor.border
      }
    },
    disabled_submit_style() {
      let btnColor = this.submitBtn.un_check;
      return {
        color: btnColor.text_color,
        background: btnColor.background_color,
      }
    },
    active_submit_style() {
      let btnColor = this.submitBtn.un_check;
      return {
        color: btnColor.text_color,
        background: btnColor.background_color,
      }
    },
    reset_btn_style() {
      let btnColor = this.resetBtn.un_check;
      return {
        color: btnColor.text_color,
        background: btnColor.background_color,
      }
    },
    validUpload() {
      let needCheck = ["photo"];
      return this.uploadList
        .filter(x => needCheck.includes(x.type))
        .every(
          x => x.show_value.length
        );
    },
    document_enum() {
      return this.formItem.document_enum || "";
    }
  },
  watch: {
    toSubmit(newVal) {
      if (!newVal) {
        //切回重新选择的页面时，再次赋值
        this.$nextTick(() => this.initOutUpload());
      }
    }
  },
  beforeCreate() {
    //一旦进入上传页，返回按钮就正常返回
    Fusion.resetBack &&
      Fusion.resetBack({
        reset: 2
      });
  },
  created() {
    //非nosubmit，展示上传区域、传过的图片
    if (!this.isNew) {
      this.toSubmit = true;
      this.uploadImgSrc = this.formItem.value[0] || '';
    }
  },
  mounted() {
    this.initOutUpload();
    if (this.isIng || this.isFailed) {
      this.submitFlag = false;
    }

  },
  methods: {
    initOutUpload() {
      //端外使用input上传
      if (!this.inApp) {
        const photoBtn = document.getElementById("photo");
        if (this.isPDF) {
          pdfReader(photoBtn, this.handleAfterChoose, this.handleImageError);
        } else {
          imgCompress(photoBtn, this.handleAfterChoose, this.handleImageError);
        }
      }
    },
    showScale() {
      this.$refs.scaleRef.show();
    },
    closeOcr() {
      this.show_ocr = false;
      this.clearImg();
    },
    toThirdLink(url) {
      console.log(url)
    },
    getCom(item) {
      return {
        input: Input,
      }[item.type];
    },
    playVideo(type) {
      if (ends.isIOS) {
        this.controlVideo();
      } else {
        this.scaleVideo = true;
      }
      if (type==='play') {
        this.controlVideo()
      }
    },
    controlVideo() {
      let examVideo = document.getElementById("video-exam");
      if (examVideo.paused) {
        examVideo.play();
      } else {
        examVideo.pause();
      }
    },
    closeBigVideo() {
      this.scaleVideo = false;
    },
    //采用澳洲方案，先传图片，再提审
    uploadImg() {
      this.uploadStart = +new Date();
      showLoadingToast(this);
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      let success = data => {
        this.toast.hide();
        if (data.low_quality_res && data.low_quality_res === 1) {
          this.canSubmit = false;
          showAlertDialog(this, data.low_quality_des);
          return false;
        }
        this.submitImg(data.img_id);
        try {
          if (this.b2md5 && !this.store_result) {
            //后半段判断，防止多次选择同一图片后，重复的set操作
            window.localStorage.setItem(this.b2md5, data.img_id);
          }
        } catch (e) {}
        Omega.trackEvent("upload_success", "", {
          duid: this._uuid || new URLSearchParams(location.search).get("uid"),
          app_upload: this.inApp,
          wait_time: new Date() - this.uploadStart,
          origin_size: this.originSize,
          compressed_size: this.compressedSize
        });
      };
      if (this.store_result) {
        success({ img_id: this.store_result });
        Omega.trackEvent("hit_img_cache_upload", "", {
          duid: this._uuid,
          app_upload: this.inApp
        });
        return;
      }
      up.append("__x_img", this.uploadImgSrc);
      up.append("type", this.formItem.key);
      up.append("document_enum", this.document_enum);

      post(process.env.UPLOAD_IMG, up)
        .then(success)
        .catch(this.httpError);
    },
    submitImg(url) {
      let up = new URLSearchParams(location.search);
      // 如果出现select-photo的内容，给他报错
      // 针对线上出现的car_lic_type传参错误进行报错提醒，并埋点观察，后续观测完就下掉
      try {
        if (this.formItem.type === 'select-photo') {
          Omega.trackEvent("ibt_register_upload_new_car_lic_type_bt", "", {
            type: 'upload-new',
            // car_lic_type: up.get('car_lic_type'),
            radio_type_key: this.formItem.radio_type_key,
            radio_type_value: this.formItem.radio_type_value,
            form_key: this.formItem.key,
            req: up.toString(),
            get_detail: JSON.stringify(this.formItem),
          });
          this.toast.hide();
          showAlertDialog(this, this.$t("出错了"));
          return;
        }
      } catch (error) {}

      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }

      // @200903 多种类型上传组件, 外层透传radio选择类型 key,value
      if (this.formItem.radio_type_key) {
        up.append(this.formItem.radio_type_key, this.formItem.radio_type_value);
      }

      // 支持任务中心,type|uid
      if (this.formItem.job_type) {
        up.append("job_type", this.formItem.job_type);
      }
      if (this.formItem.job_uid) {
        up.append("job_uid", this.formItem.job_uid);
      }

      if (this.formItem.is_ocr) {
        up.set("sPicUrl", url);
        this.ocr_img = url;
        let config = this.formItem.ocr_config;
        post(config.url, up)
          .then(data => {
            let keys = Object.keys(data);
            //formItem 中的ocr_config 做对比，赋值
            keys.forEach(item => {
              let finded = config.form.filter(x => x.key === item);
              if (finded.length) {
                finded[0].value = data[item];
              }
            });
            this.show_ocr = true;
          })
          .catch(err => showAlertDialog(this, err.errmsg || this.$t("ERROR_DEFAULT_TEXT")))
          .finally(() => {
            this.toast.hide();
          });
        return;
      }
      up.append(this.formItem.key, JSON.stringify([url]));
      // @20190213 支持任务中心,type|uid
      if (this.formItem.job_type) {
        up.append("job_type", this.formItem.job_type);
      }
      if (this.formItem.job_uid) {
        up.append("job_uid", this.formItem.job_uid);
      }
      let success = data => {
        if (this.formItem.need_next === 1) {
          this.$router.replace({ name: 'photoProgress' })
        } else {
          this.$router.replace({ name: "home" });
        }

      };

      post(process.env.ADD_AUDI_INFO, up)
        .then(success)
        .catch(err => {
          this.httpError(err);
          try {
            Omega.trackEvent("ibt_register_submit_review_error_ck", '', {
              path_url: process.env.ADD_AUDI_INFO,  //接口url
              message: JSON.stringify(err),  //全部返回信息
              request: up.toString(),  //请求参数信息
              errno: err.errno,  //报错码
            });
          } catch (e) {}
        });
    },
    clearImg() {
      this.canSubmit = false;
      this.toSubmit = false;
      this.showTip = false;
      this.uploadImgSrc = "";
      this.b2md5 = null;
      this.store_result = null;
      // this.$emit("btn-update");

    },
    selectImg() {
      if (this.isPDF) {
        Fusion.chooseFile(
          {
            file_extension: 'application/pdf', // 文件类型 (MIME type)
            // max_size: 1024*4
          },
          ret => this.handleAfterChoose(ret)
        );
      } else {
        if (this.hasChooseImage) {
          Fusion.chooseImage(
            {
              source: this.formItem.limit_status ? 2 : 3,
              quailty: 100,
              width: 1500,
              height: 1500,
            },
            (ret) => this.handleAfterChoose(ret)
          );
        } else {
          Fusion.pickImage(
            {
              width: '1500',
              height: '1500',
              source: this.formItem.limit_status ? 2 : 3,
            },
            ret => this.handleAfterChoose(ret)
          );
        }
      }
    },
    handleAfterChoose(ret) {
      if (this.isPDF) {
        // pdf上传的bridge错误码
        if (ret.errorCode === -3) {
          this.handleImageError();
          return;
        } else if (ret.errorCode === -4) {
          showAlertDialog(this, `Por favor, envie o documento em PDF`);
          return;
        }
      }
      let imgSrc
      if (this.inApp && this.hasChooseImage) {
        if (!ret) {
          return;
        }
        imgSrc = this.isPDF ? "data:application/pdf" + ";base64," + ret.fileBase64String : "data:image/jpeg" + ";base64," + ret.image;
      } else {
        if (ret.errorCode != 104) {
          return
        }
        imgSrc =  this.isPDF ? ret.fileBase64String : ret.imageBase64String;
        if (this.inApp) {
          imgSrc = this.isPDF ? "data:application/pdf" + ";base64," + ret.fileBase64String : "data:image/jpeg" + ";base64," + ret.imageBase64String;
        }
      }
      // let imgSrc = this.isPDF ? ret.fileBase64String : ret.image;
      // if (this.inApp) {
      //   // 区分是否是PDF上传
      //   imgSrc = this.isPDF ? "data:application/pdf" + ";base64," + ret.fileBase64String : "data:image/jpeg" + ";base64," + ret.image;
      // }
      this.uploadImgSrc = imgSrc;
      try {
        if (window.localStorage) {
          this.b2md5 = md5(this.uploadImgSrc);
          this.store_result = window.localStorage.getItem(this.b2md5);
          if (this.store_result) {
            Omega.trackEvent("hit_img_cache", "", {
              duid: this._uuid,
              app_upload: this.inApp
            });
          }
        }
      } catch (e) {}
      this.canSubmit = true;
      this.toSubmit = true;
      //埋点用
      this.compressedSize = imgSrc.length;
      this.originSize = ret.originSize || 0;
      //通知父级组件重新渲染
      this.$emit("btn-update");
      //@20191118 自动提交
      // if (this.formItem.is_ocr) {
        this.uploadImg();
      // }
      Omega.trackEvent("gd_oasisPreviewCertificates_sw", "", {
        type: this.formItem.key
      });
    },
    handleImageError() {
      showAlertDialog(this, this.$t("图片尺寸过大"));
    },
    httpError(res) {
      try {
        Omega.trackEvent("upload_fail", "", {
          duid: this._uuid || new URLSearchParams(location.search).get("uid"),
          app_upload: this.inApp,
          wait_time: new Date() - this.uploadStart,
          origin_size: this.originSize,
          compressed_size: this.compressedSize,
          msg: res.errmsg || res.message
        });
      } catch (e) {}
      this.toast.hide();
      showAlertDialog(this, this.$t("ERROR_DEFAULT_TEXT"));
    },
    richTextClick(event) {
      if(event.target.nodeName === 'A' && event.target.getAttribute('data-w-e-type')){
        event.preventDefault();
        const download_url = event.target.href;
        // 获取触发事件对象的属性
        if (!!Fusion.openPage) {
          Fusion.openPage && Fusion.openPage({
            url: download_url,
            newWindow: true,
            target: "native",
            browser: true
          });
        } else {
          window.open(download_url, "_blank");
        }
      
      }
    },

  }
};
</script>
<style lang="scss" scoped>
@mixin wrap {
  width: 100%;
  padding: 0.6rem 0.32rem 0 0.32rem;
  box-sizing: border-box;
  // background: #ffffff;
}
@mixin title {
  margin-bottom: 0.28rem;
  font-size: 0.36rem;
  line-height: 0.44rem;
  color: #333333;
  font-weight: 500;
}
@mixin wrapPadding {
  padding-left: .32rem;
  padding-right: .32rem;
}
.upload-new-wrap {
  // padding: .4rem 0;
  padding-bottom: 3.05rem;
  &.no-submit {
    padding-bottom: 1.33rem;
  }
  .upload-content {
    padding: .4rem 0 0.12rem 0;
    background: #fff;
    > h1 {
      line-height: .56rem;
      font-size: .48rem;
      color: #0F1928;
      margin-bottom: .4rem;
      font-weight: 500;
      @include wrapPadding;
    }
  }
  .exam-wrap {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 4.72rem;
    background-image: linear-gradient(180deg, rgba(255,255,255,0.00) 67%, rgba(145,160,180,0.10) 100%);
    .exam-pic {
      max-width: 80%;
      max-height: 80%;
    }
    .video-wrap {
      position: absolute;
      right: .32rem;
      bottom: .36rem;
      width: 1.2rem;
      height: .9rem;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 3px 6px 15px 0 rgba(64,66,80,0.62);
      #video-exam {
        width: 100%;
        height: 100%;
      }
      .exam-bg {
        position: absolute;
        width: 100%;
        height: 100%;
      }
      .play-icon {
        position: absolute;
        width: .45rem;
        height: .45rem;
      }
    }
    .video-fullscreen {
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 5;
      .bg-mask {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(15,25,40, 0.6);
      }
      #video-exam {
        position: absolute;
        left: 50%;
        top: 50%;
        // transform: translateX(-50%);
        // transform: translateY(-50%);
        transform: translate(-50%, -50%);
        // width: 100%;
        height: 300px;
        width: 100%;
      }
      .close-big-icon {
        position: absolute;
        width: 0.88rem;
        height: 0.88rem;
        bottom: 0.5rem;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
  .upload-tips,
  .obtain-tips,
  .error-case-tips {
    @include wrap;
    .tips-title {
      @include title;
    }
    .tips-desc {
      line-height: 0.4rem;
      font-size: 0.28rem;
      color: #808080;
      a {
        color: #FF7226;
        text-decoration: underline;
      }
    }
  }
  .error-case-tips {
    .case-list {
      display: flex;
      flex-wrap: wrap;
    }
    .case-wrap {
      display: inline-block;
      margin-bottom: .28rem;
      width: 3rem;
      &:nth-of-type(2n+1) {
        margin-right: .56rem;
      }
    }
    .img-wrap {
      position: relative;
      width: 3rem;
      height: 2rem;
      background: rgba(145,160,180,0.1);
    }
    .case-img {
      max-width: 100%;
      height: 100%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .case-desc {
      margin-top: .16rem;
      font-size: .2rem;
      color: #FF525D;
      line-height: .28rem;
      > img {
        width: .24rem;
        height: .24rem;
        margin-right: .1rem;
        vertical-align: top;
      }
    }
  }
  .upload-input-wrapper {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: .32rem;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0 -20px 20px 0 rgba(0,0,0,0.04);
    z-index: 1;
    .out-upload-input {
      position: relative;
      // margin: 0.4rem auto;
      // display: block;
      // width: 6.8rem;
      // height: 1.08rem;
      font-weight: 500;
      font-size: 0.32rem;
      line-height: 1.08rem;
      text-align: center;
      // font-family: "HelveticaNeue-Medium";
      color: #000;
      background: #ffe600;
      border-radius: .12rem;
      > input {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        opacity: 0;
      }
    }
  }
  &.h5_funnel_fleet,
  &.h5_funnel_fleet_pc {
    padding-bottom: 1.7rem;
    .exam-wrap {
      background: #ffffff;
    }
    .upload-input-wrapper {
      box-shadow: 0px -20px 20px 0px rgba(0,0,0,0.06);
      .out-upload-input {
        border-radius: .2rem;
        font-weight: 700;
        font-size: 0.4rem;
      }
    }
  }
  &.h5_funnel_fleet_pc {
    padding-bottom: 80px;
    .upload-content {
      padding: 16px 0;
      .exam-wrap {
        height: 180px;
        .exam-pic {
          max-width: 80%;
          max-height: 100%;
        }
      }
      .upload-tips,
      .obtain-tips,
      .error-case-tips {
        padding: 32px 16px 0 16px;
        .tips-title {
          margin-bottom: 16px;
          line-height: 22px;
          font-size: 18px;
        }
        .tips-desc,
        ::v-deep .text-link-open {
          line-height: 20px;
          font-size: 14px;
        }
      }
      .error-case-tips {
        .case-wrap {
          margin-bottom: 14px;
          width: 180px;
          &:nth-of-type(2n+1) {
            margin-right: 28px;
          }
        }
        .case-desc {
          margin-top: 8px;
          font-size: 12px;
          line-height: 12px;
          > img {
            width: 12px;
            height: 12px;
            margin-right: 5px;
          }
        }
      }
    }
    .upload-input-wrapper {
      position: absolute;
      height: 80px;
      padding: 24px;
      box-shadow: none;
      text-align: right;
      .out-upload-input {
        display: inline-block;
        padding: 6px 16px;
        box-sizing: border-box;
        height: 32px;
        line-height: 22px;
        font-size: 14px;
        font-weight: 500;
        border-radius: 4px;
      }
    }
  }
}
.reUpload-img {
  height: 100%;
  background: #ffffff;
  &.h5_funnel_fleet,
  &.h5_funnel_fleet_pc {
    .reUpload-img-header {
      height: 8.24rem;
      background: #ffffff;
    }
    .confirm-text {
      margin: .32rem;
      font-size: .36rem;
      color: #333333;
      line-height: .44rem;
      font-weight: 700;
    }
    .bottom-area {
      background: #FFFFFF;
      box-shadow: 0px -20px 20px 0px rgba(0,0,0,0.06);
      > a {
        width: 100%;
        box-sizing: border-box;
        border-radius: 0.2rem;
        font-weight: 700;
        font-size: 0.4rem;
      }
    }
  }
  &.h5_funnel_fleet_pc {
    .status-wrap {
      position: relative;
      padding: 8px 16px;
      margin-bottom: 20px;
      font-size: 14px;
      line-height: 16px;
      font-weight: 500;
      &.success {
        color: #00CCAA;
        background: rgba(0,204,170,0.1);
      }
      &.error {
        color: #FF4060;
        background: rgba(255,64,96,0.1);
      }
    }
    .reUpload-img-header {
      height: 360px;
      img {
        border-radius: 6px;
        max-width: 100%;
        max-height: 100%;
      }
    }
    .confirm-text {
      font-size: 18px;
      text-align: center;
      margin: 32px 39px;
      word-break: break-word;
      line-height: 22px;
    }
    .bottom-area {
      display: flex;
      justify-content: flex-start;
      flex-direction: row-reverse;
      position: absolute;
      height: 80px;
      padding: 24px;
      box-shadow: none;
      text-align: right;
      > a {
        width: auto;
        display: inline-block;
        padding: 6px 16px;
        box-sizing: border-box;
        height: 32px;
        line-height: 20px;
        font-size: 14px;
        font-weight: 500;
        border-radius: 4px;
        vertical-align: middle;
        &:first-child {
          margin-bottom: 0;
          margin-left: 12px;
        }
      }
    }
  }
  .reUpload-img-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 4.72rem;
    background-image: linear-gradient(180deg, rgba(255,255,255,0.00) 67%, rgba(145,160,180,0.10) 100%);
    overflow: hidden;
    img {
      max-width: 90%;
      max-height: 90%;
    }

  }
  .confirm-text {
    margin-top: .4rem;
    margin-left: .32rem;
    font-size: .48rem;
    color: #0F1928;
    line-height: .56rem;
  }
  .bottom-area {
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 0.36rem 0.32rem;
    width: 100%;
    box-sizing: border-box;
    > a {
      display: block;
      width: 6.8rem;
      height: 1.08rem;
      font-size: 0.32rem;
      line-height: 1.08rem;
      text-align: center;
      font-weight: 500;
      border-radius: 6px;
      box-sizing: border-box;
      &.btn-submit {
        color: #000;
        background: #ffe600;
      }
      &.btn-reUpload {
        color: #333;
        background: #fff;
        border: 1px solid #999;
      }
      &:first-child {
        margin-bottom: 0.2rem;
      }
    }
  }
}
.status-wrap {
  position: sticky;
  // position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  padding: 0.3rem 0.32rem;
  box-sizing: border-box;
  font-size: 0.32rem;
  color: #ffffff;
  &.ing {
    background: #91A0B4;
  }
  &.success {
    background: #18C47C;
  }
  &.fail{
    background: #FF525D;
  }
}
</style>
